export const formatDate = (dateString: string): string => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString();
};

export const getCurrentDate = (): string => {
    return new Date().toLocaleDateString();
};

export const getDefaultDueDate = (): string => {
    return new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString();
};

export const formatDueDate = (dueDate?: string): string => {
    return dueDate ? formatDate(dueDate) : getDefaultDueDate();
}; 